import 'bootstrap.modal';

document.addEventListener('setQuestion', e => {
    document.getElementById('new-product-listing-answer-title').innerText = e.detail.question;
    document.getElementById('new-product-listing-answer-question-id').value = e.detail.id;
});